// Centralized registry of pending-flush callbacks.
// Each store or composable with a throttled write registers its flush function here.
// A single router.beforeEach guard calls flushAll() before every navigation,
// ensuring no in-flight throttled writes are lost on route change.

const registry = new Set<() => void>();

export function registerFlush(fn: () => void): void {
    registry.add(fn);
}

export function unregisterFlush(fn: () => void): void {
    registry.delete(fn);
}

export function flushAll(): void {
    registry.forEach((fn) => fn());
}
